import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: 15px;\n  p {\n    margin: 0;\n  }\n'], ['\n  margin-bottom: 15px;\n  p {\n    margin: 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 600;\n  text-transform: uppercase;\n'], ['\n  color: ', ';\n  font-weight: 600;\n  text-transform: uppercase;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-weight: 600;\n'], ['\n  font-weight: 600;\n']);

import styled from 'styled-components';

export var StyledWrapper = styled.div(_templateObject);

export var StyledSpan = styled.span(_templateObject2, function (props) {
  return props.theme.dormifyPink;
});
export var BoldSpan = styled.span(_templateObject3);